import RadioColor from './RadioColor';

export default RadioColor;
